import React, {useEffect, useMemo, useState} from "react";
import {Input, Modal, Pagination, Space, Table} from "antd";
import queryApi from "api/queryApi";
import {columnsCardUser, dataTab} from "../../BankCardsData";
import {useTranslation} from "react-i18next";
import {useColumnSearchProps} from "../../../../libs/columnFilter";
import {columnsCardWithContracts, dataCardWithContractsTab} from "../CardRegistryData";

const { Search } = Input;


const CardSelectModal = ({ open, onCancel, onSelect, selectedCards, contractId }) => {

    const { t } = useTranslation()

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(true)
    const [dataCards, setDataCards] = useState();

    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);

    const onShowSizeChange = (current, pageSize) => {
        console.log(current, pageSize);
    };
    const handlePageChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    useEffect(()=>{
        if (open) {
            setSelectedRowKeys(selectedCards.map((c) => c.mbat_id))
        }
    }, [open, selectedCards])

    const rowSelection = useMemo(() => ({
        selectedRowKeys,
        onChange: setSelectedRowKeys,
    }), [selectedRowKeys])

    const getTabData = async (filter = '') => {

        let filters = [];
        if (filter!=='' && filter!== '{}') filters = filter

        const queryParams = new URLSearchParams({
            linesPerPage: pageSize,
            pageNum: currentPage,
        });
        let defFilter=[];
        if (contractId !== "") defFilter = [{"column":"parent_contract_id","value":contractId, "operator":"=", "dataType":"number"}]
        dataCardWithContractsTab.query['filters'] = filters;
        dataCardWithContractsTab.query.filters.push(...defFilter)

        const { data } = await queryApi.post(`/query/paging?${queryParams.toString()}`,
            ( dataCardWithContractsTab ));
        setDataCards(data.data);
        setTotalRows(data.totalRowCount);

        setLoading(false);


    };

    useEffect(() => {
        getTabData();

    }, [currentPage, pageSize]);

    const handleOk = () => {
        const selected = dataCards.filter((card) =>
            selectedRowKeys.includes(card.mbat_id)
        );
        onSelect(selected);
       // setSelectedRowKeys([]);
    };

    const onSearch = (val) => {
        const filterVal = [
             { "column": "embossed_name", "value": val, "operator": "_like_", "dataType": "text" }
        ];
        val === ''?getTabData():getTabData(filterVal);
    }

    const tableHeader = () => {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 10 }}>
                <Search
                    style={{width:'35%'}}
                    placeholder={t('embossedName')}
                    allowClear
                    enterButton="Фильтр"
                    size="middle"
                    onSearch={onSearch}
                />
            </div>
        )
    }

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            onOk={handleOk}
            title="Выбор карт"
            width="60%"
            style={{top: 30}}
        >
            <div style={{position: 'relative', height: '100%'}}>

                <Space direction="horizontal" style={{width: '100%', justifyContent: 'right', margin: '16px 0'}}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={totalRows}
                        onChange={handlePageChange}
                        onShowSizeChange={onShowSizeChange}
                        size='small'
                        defaultCurrent='1'
                        hideOnSinglePage={false}
                        showTotal={(total, range) => (
                            <span>
                                <strong>{total}</strong> катордан {range[0]}-{range[1]} гача
                            </span>
                        )}
                    />
                </Space>
                <Table
                    rowKey="mbat_id"
                    dataSource={dataCards}
                    rowSelection={rowSelection}
                    pagination={false}
                    title={tableHeader}
                    scroll={{y: 'calc(55vh)'}}
                    columns={columnsCardWithContracts(t)}
                />
            </div>

        </Modal>
);
};

export default React.memo(CardSelectModal);